export default "__VITE_ASSET__2WqZbZH9__"